import chooseReportType from './chooseReportType';
import initializeGateways from './initializeGateways';
import navigateToFinalise from './navigateToFinalise';
import sendEditTitleAnalyticsEvent from './sendEditTitleAnalyticsEvent';
import sendEditAgentBioAnalyticsEvent from './sendEditAgentBioAnalyticsEvent';
import uploadPdf from './uploadPdf';
import {loadPreferences, updatePreferences} from './preferences';
import {addCoverImage} from './coverImagesUtil';

const DefaultGateways = {
  initializeGateways,
  chooseReportType,
  loadPreferences,
  navigateToFinalise,
  sendEditTitleAnalyticsEvent,
  sendEditAgentBioAnalyticsEvent,
  addCoverImage,
  uploadPdf,
  updatePreferences,
};

export default DefaultGateways;
